import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { backendPatchWithoutRefresh } from "../../../helpers/callBackend";
import GenericModal from "../../buttons/genericModal";
import Button from '@mui/material/Button';
import { Form } from "antd";


function MarkNoLongerPendingModal(props) {
    const [submitting, setSubmitting] = useState(false);

    const onFormSubmitModal = async () => {
        setSubmitting(true);
        backendPatchWithoutRefresh(
            "/api/transactions/",
            {
                id: props.selectedTransaction.id,
                mark_no_longer_pending: true,
            }
        ).then(() => {
            setSubmitting(false);
            props.setShowMarkNoLongerPendingModal(false);
        })
            .catch((error) => {
                setSubmitting(false);
                console.error(error);
            });
    };

    return (
        <GenericModal
            visible={props.showMarkNoLongerPendingModal}
            handleCancelModal={() => props.setShowMarkNoLongerPendingModal(false)}
            showModal={() => props.setShowMarkNoLongerPendingModal(true)}
            size="sm"
            button={<Button disableElevation fullWidth size="small" variant="outlined" color="secondary" sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}>Mark no longer pending</Button>}
            modalTitle={"Mark no longer pending"}
            modalBody={
                <Form
                    layout="vertical"
                    name="basic"
                    autoComplete="off"
                > Are you sure you want to mark the selected transaction as no longer pending?
                    <LoadingButton onClick={onFormSubmitModal} loading={submitting} loadingPosition="start" disableElevation fullWidth size="small" variant="contained" color="primary" sx={{ fontSize: 14, marginTop: 2, width: '100%', textTransform: 'none' }}>Submit</LoadingButton>
                </Form>
            }
        />
    );
}

export default MarkNoLongerPendingModal;
